"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataSelectorId = exports.config = void 0;
const helpers_1 = require("../../helpers");
exports.config = {
    paddingOrMarginLeft: helpers_1.SPACING_L,
    paddingOrMarginRight: helpers_1.SPACING_M
};
exports.dataSelectorId = {
    simpleBody: 'pagewizard-wizard-body',
    bodyWithHeaderOrFooter: 'pagewizard-wizard-complex-content'
};
//# sourceMappingURL=helpers.js.map